import { memo } from "react";
import { StyledWrap, StyledText } from "./styles";

type InnerLoaderProps = {
    text: string;
};

const InnerLoader = ({ text }: InnerLoaderProps) => {
    return (
        <StyledWrap data-automation="contacts-actions-panel.loader">
            <StyledText>{text}...</StyledText>
        </StyledWrap>
    );
}

export default memo(InnerLoader);
